/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const overrideDetailResponseOutputOverrideIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const overrideDetailResponseOutputRoutineIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const overrideDetailResponseOutputScheduleIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const overrideDetailResponseOutputVersionExclusiveMin = 0;
export const overrideDetailResponseOutputVersionMax = 9007199254740991;

export const overrideDetailResponseOutputStartRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const overrideDetailResponseOutputEndRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const overrideDetailResponseOutputSubstituteUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const overrideDetailResponseOutputReasonOneMax = 1000;

export const OverrideDetailResponseOutput = zod.object({
  overrideId: zod.uuid().regex(overrideDetailResponseOutputOverrideIdRegExp),
  routineId: zod.uuid().regex(overrideDetailResponseOutputRoutineIdRegExp),
  scheduleId: zod.uuid().regex(overrideDetailResponseOutputScheduleIdRegExp),
  version: zod
    .int()
    .gt(overrideDetailResponseOutputVersionExclusiveMin)
    .max(overrideDetailResponseOutputVersionMax),
  start: zod.iso.datetime({ offset: true }).regex(overrideDetailResponseOutputStartRegExp),
  end: zod.iso.datetime({ offset: true }).regex(overrideDetailResponseOutputEndRegExp),
  substituteUserId: zod.uuid().regex(overrideDetailResponseOutputSubstituteUserIdRegExp),
  reason: zod.union([zod.string().max(overrideDetailResponseOutputReasonOneMax), zod.null()]),
  state: zod.enum(['active', 'canceled']),
  editable: zod.boolean(),
});

export type OverrideDetailResponseOutput = zod.input<typeof OverrideDetailResponseOutput>;
export type OverrideDetailResponseOutputOutput = zod.output<typeof OverrideDetailResponseOutput>;
